import { firestore } from '@psl/functions/firebase/firebaseAccess';
import { CategorizedResourceType } from '@psl/models/ClientModels';

export const storeCategorizedResourcesQuery = (uid: string, limit?: number) => {
  const query = firestore()
    .collection('categorizedResources')
    .where('resourceType', '==', CategorizedResourceType.Store)
    .where('storeId' as any, '==', uid);
  return limit != null ? query.limit(limit) : query;
};
